export default "__VITE_ASSET__6788a0fc__"